export var SteuerberaterTokenStatus;
(function (SteuerberaterTokenStatus) {
    SteuerberaterTokenStatus["ACTIVE"] = "ACTIVE";
    SteuerberaterTokenStatus["REVOKED"] = "REVOKED";
})(SteuerberaterTokenStatus || (SteuerberaterTokenStatus = {}));
//# sourceMappingURL=steuerberater-token-status.js.map